export const ru = {
    'streams-error': 'Не удалось получить список текущих трансляций',
    'upcoming-streams-error': 'Не удалось получить запланированных трансляций',
};
